import { Component } from '@angular/core';

@Component({
    selector: 'ct-user-avatar',
    templateUrl: 'user-avatar.component.html',
    styleUrls: ['user-avatar.component.less']
})
export class UserAvatarComponent {
}
